import './CustomToolTip.css';
import React from 'react';

import { formatDate, formatDateTime, formatNumber } from '../../util/formatters';
import { formatCurrency } from '../../util/util';
import { Dataset } from './AreaChart';

interface Payload {
  payload: {
    label: string;
  };
}

interface Props {
  active?: boolean;
  payload?: Payload[];
  dataSets: Dataset[];
  labels: string[];
  title?: (index: number) => string;
  formatValues?: 'currency';
  showHour?: boolean;
}

export function CustomToolTip({
  dataSets,
  labels,
  active,
  payload,
  title,
  formatValues,
  showHour,
}: Props): JSX.Element | null {
  if (!active || !payload) {
    return null;
  }

  const index = labels.indexOf(payload[0].payload.label);

  return (
    <div className="custom-tooltip">
      {dataSets.map((dataset) => (
        <div className="custom-tooltip__field-wrapper" key={dataset.title}>
          <div className="custom-tooltip__label-wrapper">
            <svg width="10px" height="10px">
              <circle cx="5" cy="5" r="4" fill={dataset.color} stroke={dataset.color} />
            </svg>
            <span className="custom-tooltip__label">{dataset.title}</span>
          </div>
          <div className="custom-tooltip__value-wrapper">
            <span className="custom-tooltip__value">
              {showHour
                ? `${formatDateTime(payload[0].payload.label)} - `
                : `${formatDate(payload[0].payload.label)} - `}
              {formatValues === 'currency'
                ? formatCurrency(dataset.values[index])
                : formatNumber(dataset.values[index], 0)}
            </span>
          </div>
        </div>
      ))}
      {title && <div className="custom-tooltip__field-wrapper">{title?.(index)}</div>}
    </div>
  );
}
